import ErrorPage from './default';
import { PROMO_EXPIRED_FA as TEXTS } from './constants';

function PromoExpiredTv(props) {
  return (
    <ErrorPage
      {...props}
      title={TEXTS.TITLE}
      description={TEXTS.DESCRIPTION}
      iconColor="BLUE"
      iconId="informacion"
      buttonText={TEXTS.BUTTON_TEXT}
      buttonHref={TEXTS.BUTTON_HREF}
      showLink={false}
      componentContent="promo-expired-fa"
    />
  );
}
export default PromoExpiredTv;
